module.exports = __webpack_public_path__ + "static/media/animal_music_band_guitar.c51737a1.png";